import _regeneratorRuntime from "/builds/sites/ondacero-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint-disable no-underscore-dangle */


import waitForLoad from '@atresmedia/a3utils/dist/utils/waitForLoad';
import { cmpLog, LOG_TYPE_CORE, INITIALIZING, LOG_TYPE_INFO, GET_VENDORS_LIST, SUCCESS, FAILED, GET_VENDORS_LIST_FAILED, GET_CONSENTS_REQUEST, GET_CONSENTS_FAILED, LOG_TYPE_ERROR, INITIALIZING_FAILED, FIRE_CALLBACK, LOG_TYPE_EXTENDED, CMP_CHANGES, GET_OTHER_VENDORS_LIST, GET_OTHER_VENDORS_LIST_FAILED, CONSENT_READY, CONSENT_CHANGED } from './logger';
import { checkConsents, checkVendorPurposes, CONSENTS_INTERFACE } from './consentUtils';
window.consents = _objectSpread({}, CONSENTS_INTERFACE);
var isReady = false;

var reduceConsents = function reduceConsents(vendorConsent) {
  return Object.keys(vendorConsent).reduce(function (ids, id) {
    if (vendorConsent[id]) {
      ids.push(Number(id));
    }

    return ids;
  }, []);
};

var updateConsents = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tcData) {
    var updatedConsents, results;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            checkConsents(tcData);
            updatedConsents = _objectSpread({}, window.consents);
            updatedConsents.vendors = reduceConsents(tcData.vendor.consents);
            updatedConsents.purposes = reduceConsents(tcData.purpose.consents);
            updatedConsents.tcString = tcData.tcString;
            updatedConsents.filteredVendors = [];
            cmpLog(LOG_TYPE_INFO, GET_CONSENTS_REQUEST, tcData);
            _context.next = 9;
            return Promise.all(updatedConsents.vendors.map(function (id) {
              return checkVendorPurposes(id);
            }));

          case 9:
            results = _context.sent;
            results.forEach(function (r, index) {
              if (r) {
                updatedConsents.filteredVendors.push(updatedConsents.vendors[index]);
              }
            });
            window.consents = _objectSpread(_objectSpread({}, window.consents), updatedConsents);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function updateConsents(_x) {
    return _ref.apply(this, arguments);
  };
}();

var cmpCallback = function cmpCallback(tcData, success) {
  cmpLog(LOG_TYPE_INFO, FIRE_CALLBACK, success ? SUCCESS : FAILED);
  cmpLog(LOG_TYPE_EXTENDED, CMP_CHANGES + tcData.tcString !== window.consents.tcString);

  if (success) {
    // TC Loaded
    if (tcData.eventStatus === 'tcloaded' && !isReady) {
      if (window._satellite) {
        cmpLog(LOG_TYPE_INFO, CONSENT_READY);

        window._satellite.track('consentReady');

        isReady = true;
      }
    } // User Action Complete


    if (tcData.eventStatus === 'useractioncomplete') {
      if (window._satellite) {
        if (!isReady) {
          cmpLog(LOG_TYPE_INFO, CONSENT_READY);

          window._satellite.track('consentReady');

          isReady = true;
        } else {
          cmpLog(LOG_TYPE_INFO, CONSENT_CHANGED);

          window._satellite.track('consentChanged');
        }
      }
    }
  }
};

var loadData = function loadData(_ref2) {
  var beforeReady = _ref2.beforeReady,
      onOtherVendors = _ref2.onOtherVendors,
      listeners = _ref2.listeners;
  cmpLog(LOG_TYPE_CORE, INITIALIZING); // Guardamos todos los consentimientos en window

  var getVendorsData = function getVendorsData() {
    return new Promise(function (resolve, reject) {
      return window.__tcfapi('getVendorList', 2, function (gvl, success) {
        cmpLog(LOG_TYPE_INFO, GET_VENDORS_LIST, success ? SUCCESS : FAILED, gvl);

        if (success) {
          var updatedConsents = _objectSpread({}, window.consents);

          updatedConsents.vendorsList = _objectSpread({}, gvl.vendors);
          updatedConsents.purposesList = _objectSpread({}, gvl.purposes);
          window.consents = _objectSpread(_objectSpread({}, window.consents), updatedConsents);
          resolve();
        } else {
          console.warn(GET_VENDORS_LIST_FAILED);
          reject(new Error(GET_VENDORS_LIST_FAILED));
        }
      });
    });
  }; // Obtenemos la cadena de consentimientos


  var getTcData = function getTcData() {
    return new Promise(function (resolve, reject) {
      return window.__tcfapi('getTCData', 2, function (tcData, success) {
        cmpLog(LOG_TYPE_INFO, GET_CONSENTS_REQUEST, success ? SUCCESS : FAILED);

        if (success) {
          resolve(tcData);
        } else {
          cmpLog(LOG_TYPE_ERROR, GET_CONSENTS_FAILED);
          reject(new Error(GET_CONSENTS_FAILED));
        }
      });
    });
  };

  var getOtherVendorsData = function getOtherVendorsData() {
    return new Promise(function (resolve, reject) {
      window.__tcfapi('getOtherVendorConsents', 2, /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, success) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  cmpLog(LOG_TYPE_INFO, GET_OTHER_VENDORS_LIST, success ? SUCCESS : FAILED, data);
                  _context2.prev = 1;

                  if (!onOtherVendors) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return onOtherVendors(data, success);

                case 5:
                  resolve(data, success);
                  _context2.next = 12;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t0 = _context2["catch"](1);
                  cmpLog(LOG_TYPE_ERROR, GET_OTHER_VENDORS_LIST_FAILED);
                  reject(new Error(GET_VENDORS_LIST_FAILED));

                case 12:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[1, 8]]);
        }));

        return function (_x2, _x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    });
  };

  Promise.all([getTcData(), getVendorsData(), getOtherVendorsData()]).then(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 1),
        consentsData = _ref5[0];

    updateConsents(consentsData);
    document.getElementById('acceptAllMain').addEventListener('click', function () {
      window.consents = _objectSpread(_objectSpread({}, window.consents), {}, {
        purposeAccepted: true
      });
    });

    window.__tcfapi('addEventListener', 2, /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(tcData, success) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(tcData.tcString !== window.consents.tcString)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 3;
                return Promise.all([getVendorsData(), getOtherVendorsData()]);

              case 3:
                _context3.next = 5;
                return updateConsents(tcData);

              case 5:
                if (!beforeReady) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return beforeReady(tcData, success);

              case 8:
                if (listeners) {
                  listeners.forEach(function (l) {
                    return l(tcData, success);
                  });
                }

                cmpCallback(tcData, success);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4, _x5) {
        return _ref6.apply(this, arguments);
      };
    }());
  })["catch"](function (e) {
    return cmpLog(LOG_TYPE_ERROR, INITIALIZING_FAILED, e);
  });
};

export default (function (data) {
  var onLoad = data.onLoad;
  return waitForLoad(window, '__tcfapi').then(function () {
    if (onLoad) {
      onLoad();
    }

    loadData(data);
  });
});